module.exports = __webpack_public_path__ + "assets/img/8_1546_big.00baf1c2.jpg";